var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-container"},[_c('div',{staticClass:"header-bar"}),_c('div',{staticClass:"group-container"},_vm._l((_vm.groupList),function(group){return _c('group-item',{key:group.groupID,attrs:{"group":group}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }